import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto";
import "@cdk-uip/icons";
import "@cdk-uip/react/cdk.css";
import "./index.css";
import App from "./components/App";

// Render the app
ReactDOM.render(<App />, document.getElementById("root"));
